import { render, staticRenderFns } from "./WorkContractList.vue?vue&type=template&id=31561312&"
import script from "./WorkContractList.vue?vue&type=script&lang=js&"
export * from "./WorkContractList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports